<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<button
  class="general-button"
  [style.height.px]="buttonHeight()"
  [ngClass]="buttonClass()"
  [type]="buttonType()"
  [disabled]="disabled()"
  (click)="buttonClicked.emit($event)">

  @if (iconStart()) {
    <mat-icon class="general-button-icon" aria-hidden="false" [svgIcon]="iconStart() || ''" />
  }

  {{buttonName() | translate}}

  @if (iconEnd()) {
    <mat-icon class="general-button-icon" aria-hidden="false" [svgIcon]="iconEnd() || ''" />
  }

</button>
